<script setup lang="ts">
import EiIcon from "@/components/icons/EiIcon.vue";
</script>

<template>
    <div id="main-mobile-footerbar" class="rodape overflow-hidden">
        <nav class="fixed-bottom">
            <div class="container text-center">
                <div class="row justify-content-center mt-2 align-middle">
                    <div class="col-3 col-sm-2 align-middle">
                    </div>
                    <div class="col-3 col-sm-2 button-link align-middle icone-ei p-1">
                        <ei-icon />
                    </div>
                    <div class="col-3 col-sm-2 button-link align-middle">
                    </div>
                </div>
            </div>
        </nav>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "RodapeComponent",
    data() {
        return {

        }
    },
    methods: {
    }
})
</script>

<style scoped>
.rodape>nav {
    background-color: #eeeeee !important;
    height: 50px !important;
}

.icone-ei>svg {
    height: 20px;
}
</style>